import { Order } from '@apis/index'
import { Config } from '@apis/types'
import { Status, Table, TableActions, TableUser } from '@components'
import AssignModal from '@components/alert/driverAssignModal'
import TableDate from '@components/table/date'
import { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

const BookLent = () => {
  const { id } = useParams()
  const [order, setOrder] = useState(null)
  const [visible, setVisible] = useState(false)
  const {
    items: bookList,
    totalPages,
    loading,
  } = useSelector((state: any) => state.userBookLent)
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    userId: id,
    type: 'Lend',
  })
  const fetchBookLent = async (
    action: Config['store']['action'],
    params: any,
  ) => {
    await Order.getAllBookLent(action, params).catch(() => {})
  }
  useEffect(() => {
    if (!bookList?.length) {
      fetchBookLent('set', params)
    }
  }, [])

  const lendColumns = [
    {
      title: 'Book Name',
      key: 'lendName',
      render: (order: any) => (
        <TableUser
          bookCover
          avatar={order?.bookData?.coverImage}
          label={order?.bookData?.name}
          secondaryLabel={order?.bookData?.author}
        />
      ),
    },
    {
      title: 'Lender',
      key: 'lendLender',
      render: (order: any) => (
        <TableUser
          hasAvatar
          avatar={
            order?.bookData?.userCreated?.image ??
            order?.bookData?.adminCreated?.image
          }
          label={
            order?.bookData?.userCreated?.name ??
            order?.bookData?.adminCreated?.name
          }
          secondaryLabel={order?.bookData?.userCreated?.phoneNo ?? null}
        />
      ),
    },
    {
      title: 'Borrower',
      key: 'lendBorrower',
      render: (order: any) => (
        <TableUser
          hasAvatar
          avatar={order?.userCreated?.image}
          label={order?.userCreated?.name}
          secondaryLabel={order?.userCreated?.phoneNo}
        />
      ),
    },
    {
      title: 'Expiry Date',
      key: 'lendDate',
      render: (order: any) => (
        <TableDate date={order?.returnDate} hasTime={false} />
      ),
    },
    {
      title: 'Driver',
      key: 'lendPickupDriver',
      render: (order: any) => (
        <TableUser
          label={order?.pickUpDriver?.name ?? '-'}
          secondaryLabel={order?.pickUpDriver?.phoneNo}
        />
      ),
    },
    {
      title: 'Status',
      key: 'lendStatus',
      render: (order: any) => <Status status={order?.status} />,
    },

    {
      title: 'Action',
      key: 'lendAction',
      render: (item: any) => (
        <>
          {item?.status === 'Pending' || item?.status === 'Delivered' ? (
            <TableActions
              hasCustom
              hasEdit={false}
              hasDelete={false}
              hasView={false}
              customTitle="Assign"
              onCustom={() => {
                setOrder(item)
                setVisible(true)
              }}
            />
          ) : (
            '-'
          )}
        </>
      ),
    },
  ]

  return (
    <Fragment>
      <Table
        columns={lendColumns}
        data={bookList}
        loading={loading}
        paginationProps={{
          totalPages: totalPages,
          perPage: params.limit,
          activePage: params?.page,
          handleOnClick: (pageNo) => {
            const updateParams = { ...params, page: pageNo }
            setParams(updateParams)
            fetchBookLent('set', updateParams)
          },
        }}
      />
      <AssignModal
        visible={visible}
        order={order}
        setVisible={setVisible}
        onCancel={() => {
          setOrder(null)
          setVisible(false)
        }}
      />
    </Fragment>
  )
}

export default BookLent
